import { useState } from "react";
import DataTable from "../../components/common/DataTable";

const invoices = [
  {
    id: "#GST-2026-042", date: "Feb 14, 2026", customer: "Nexus Labs Corp", initials: "NL",
    color: "bg-blue-100 text-blue-600", amount: "$4,250.00", status: "Paid", month: "February 2026",
  },
  {
    id: "#GST-2026-039", date: "Feb 09, 2026", customer: "Aether Systems", initials: "AS",
    color: "bg-orange-100 text-orange-600", amount: "$1,120.00", status: "Unpaid", month: "February 2026",
  },
  {
    id: "#GST-2026-021", date: "Jan 28, 2026", customer: "Vortex Media", initials: "V",
    color: "bg-purple-100 text-purple-600", amount: "$8,900.00", status: "Paid", month: "January 2026",
  },
  {
    id: "#GST-2026-015", date: "Jan 12, 2026", customer: "Quantum Prime", initials: "QP",
    color: "bg-teal-100 text-teal-600", amount: "$5,600.00", status: "Overdue", month: "January 2026",
  },
];

const statusConfig = {
  Paid: { text: "text-emerald-600", bg: "bg-emerald-50", border: "border-emerald-200", dot: "bg-emerald-400" },
  Unpaid: { text: "text-amber-600", bg: "bg-amber-50", border: "border-amber-200", dot: "bg-amber-400" },
  Overdue: { text: "text-red-500", bg: "bg-red-50", border: "border-red-200", dot: "bg-red-400" },
};

const stats = [
  { label: "Total Invoices", value: "1,284", badge: "+12%", badgeColor: "text-[#34094D] bg-[#E9BCFE4D]", extra: null },
  { label: "Grand Total", value: "$142k", badge: null, icon: true },
  { label: "Paid", value: "$118k", badge: "83%", badgeColor: "text-[#16A34A] bg-[#F0FDF4]" },
  { label: "Unpaid", value: "$18.4k", badge: "13%", badgeColor: "text-[#EA8534] bg-[#EA85341A]" },
  { label: "Overdue", value: "$5.6k", badge: "4%", badgeColor: "text-[#BA1A1A] bg-[#FFDAD64D]", valueColor: "text-[#DC2626]" },
];

const SearchIcon = () => (
  <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
    <circle cx="11" cy="11" r="8" /><path d="M21 21l-4.35-4.35" strokeLinecap="round" />
  </svg>
);

const CalendarIcon = () => (
  <svg className="w-4 h-4 text-violet-500" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
    <rect x="3" y="4" width="18" height="18" rx="2" /><path d="M16 2v4M8 2v4M3 10h18" strokeLinecap="round" />
  </svg>
);

const DownloadIcon = () => (
  <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
    <path d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M12 4v12m-4-4l4 4 4-4" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const ChevronDown = () => (
  <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
    <path d="M6 9l6 6 6-6" strokeLinecap="round" />
  </svg>
);

const BoxIcon = () => (
  <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
    <path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z" />
  </svg>
);

export default function GSTInvoices() {
  const [search, setSearch] = useState("");
  const [yearFilter, setYearFilter] = useState("Year 2026");
  const [statusFilter, setStatusFilter] = useState("All Status");

  const columns = [
    {
      accessorKey: "id",
      header: "Invoice No.",
      cell: (info) => (
        <span className="text-sm font-bold text-violet-700">{info.getValue()}</span>
      ),
    },
    {
      accessorKey: "date",
      header: "Date",
      cell: (info) => (
        <span className="text-sm text-gray-500">{info.getValue()}</span>
      ),
    },
    {
      accessorKey: "customer",
      header: "Customer",
      cell: (info) => {
        const row = info.row.original;
        return (<>
          <div className="flex items-center gap-2">
            <span className={`w-8 h-8 rounded-full flex items-center justify-center text-xs font-bold flex-shrink-0 ${row.color}`}>
              {row.initials}
            </span>
            <span className="text-sm text-gray-800 font-medium leading-tight">{info.getValue()}</span>
          </div>
        </>);
      },
    },
    {
      accessorKey: "amount",
      header: "Amount",
      cell: (info) => (
        <span className="text-sm font-semibold text-gray-800">{info.getValue()}</span>
      ),
    },
    {
      accessorKey: "status",
      header: "Status",
      cell: (info) => {
        const status = info.getValue();
        const s = statusConfig[status];
        return (
          <span className={`inline-flex items-center gap-1.5 text-xs font-semibold px-2.5 py-1 rounded-full border ${s.bg} ${s.text} ${s.border}`}>
            <span className={`w-1.5 h-1.5 rounded-full ${s.dot}`}></span>
            {status}
          </span>
        );
      },
    },
    {
      accessorKey: "id",
      header: "Action",
      cell: () => (
        <button className="w-8 h-8 rounded-full bg-violet-600 hover:bg-violet-700 flex items-center justify-center shadow-sm transition-all">
          <DownloadIcon />
        </button>
      ),
    },
  ];

  return (


        <div className="flex-1 px-8 py-7 overflow-y-auto">
          {/* Header */}
          <div className="mb-6">
            <h1 className="text-[36px] font-bold text-[#34094D] tracking-tight">GST Invoices</h1>
            <p className="text-[16px] font-regular text-[#4C444E] mt-1">
              Manage your digital financial identity. Access, filter, and export your GST records with precision and speed.
            </p>
          </div>

          {/* Stats Cards */}
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 mb-8">
            {stats.map((stat, i) => (
              <div key={i} className="bg-white rounded-[16px] shadow-[0px_8px_24px_0px_#4B23640A] px-4 py-4">
                <p className="text-[14px] font-medium text-[#4C444E] uppercase tracking-wider mb-2">{stat.label}</p>
                <div className="flex items-end gap-2 flex-wrap">
                  <span className={`text-[30px] font-bold tracking-tight ${stat.valueColor || "text-[#191C1D]"}`}>
                    {stat.value}
                  </span>
                  {stat.badge && (
                    <span className={`text-xs font-semibold px-1.5 py-0.5 rounded-md ${stat.badgeColor}`}>
                      {stat.badge}
                    </span>
                  )}
                  {stat.icon && <BoxIcon />}
                </div>
              </div>
            ))}
          </div>

          {/* Filter Row */}
          <div className="flex flex-wrap justify-between bg-[#F3F4F5] p-5 rounded-[24px] items-center gap-3 mb-6">
            <div className="flex flex-wrap items-center gap-3">
              {/* Search */}
              <div className="flex items-center gap-2 bg-white rounded-[12px] px-3 py-2.5">
                <SearchIcon />
                <input
                  type="text"
                  placeholder="Search by invoice or customer..."
                  className="text-[14px] text-[#191C1D] placeholder:text-[#7D747F99] outline-none bg-transparent w-56"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </div>
            </div>
             <div className="flex flex-wrap gap-3"> 
                {/* Year Filter */}
              <div className="relative">
                <select
                  className="appearance-none bg-white text-[14px] text-[#191C1D] font-semibold pl-4 pr-12 py-2.5 rounded-[12px] cursor-pointer focus:outline-none focus:ring-2 focus:ring-violet-300"
                  value={yearFilter}
                  onChange={(e) => setYearFilter(e.target.value)}
                >
                  <option>Year 2026</option>
                  <option>Year 2025</option>
                  <option>Year 2024</option>
                </select>
                <span className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-[#94A3B8]">
                  <svg className="w-4 h-4" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" />
                  </svg>
                </span>
              </div>

                {/* Status Filter */}
                <div className="relative">
                  <select
                    className="appearance-none bg-white text-[14px] text-[#191C1D] font-semibold pl-4 pr-12 py-2.5 rounded-[12px] cursor-pointer focus:outline-none focus:ring-2 focus:ring-violet-300"
                    value={statusFilter}
                    onChange={(e) => setStatusFilter(e.target.value)}
                  >
                    <option>All Status</option>
                    <option>Paid</option>
                    <option>Unpaid</option>
                    <option>Overdue</option>
                  </select>
                  <span className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-[#94A3B8]">
                    <svg className="w-4 h-4" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" />
                    </svg>
                  </span>
                </div>

              {/* Apply Filters */}
              <button className="flex items-center gap-2 bg-[#34094D] text-white text-[14px] font-semibold px-5 py-2.5 rounded-[12px] border-none cursor-pointer hover:opacity-90 transition-opacity">
                Apply Filters
              </button>
            </div>
          </div>   
          {/* Invoice Table */}
          <div className="bg-white rounded-[20px] shadow-[0px_8px_24px_rgba(75,35,100,0.04)] border border-[#F0EBF4] overflow-hidden">

            {/* Table Header */}
            <div className="grid grid-cols-6 px-6 py-4 bg-[#F9FAFB] border-b border-[#F0EBF4]">
              {["Invoice No.", "Date", "Customer", "Amount", "Status", "Action"].map((h) => (
                <p key={h} className="text-[11px] font-bold text-[#7D747F] uppercase tracking-wider">{h}</p>
              ))}
            </div>

            {/* Rows */}
            {invoices
              .filter(inv =>
                (statusFilter === "All Status" || inv.status === statusFilter) &&
                (inv.id.toLowerCase().includes(search.toLowerCase()) || inv.customer.toLowerCase().includes(search.toLowerCase()))
              )
              .map((inv, i, arr) => {
                const s = statusConfig[inv.status];
                return (
                  <div
                    key={inv.id}
                    className={`grid grid-cols-6 px-6 py-4 items-center hover:bg-[#FAFAFA] transition-colors ${
                      i !== arr.length - 1 ? "border-b border-[#F3F4F5]" : ""
                    }`}
                  >
                    {/* Invoice No */}
                    <div>
                      <p className="text-[13px] font-bold text-[#4B2364]">{inv.id}</p>
                      <p className="text-[11px] text-[#7D747F] mt-0.5">{inv.month}</p>
                    </div>

                    {/* Date */}
                    <p className="text-[13px] text-[#4C444E] font-medium">{inv.date}</p>

                    {/* Customer */}
                    <div className="flex items-center gap-2.5">
                      <span className={`w-8 h-8 rounded-full flex items-center justify-center text-[11px] font-bold shrink-0 ${inv.color}`}>
                        {inv.initials}
                      </span>
                      <span className="text-[13px] font-semibold text-[#191C1D]">{inv.customer}</span>
                    </div>

                    {/* Amount */}
                    <p className="text-[14px] font-bold text-[#191C1D]">{inv.amount}</p>

                    {/* Status */}
                    <span className={`inline-flex items-center gap-1.5 text-[11px] font-bold px-2.5 py-1 rounded-full w-fit border ${s.bg} ${s.text} ${s.border}`}>
                      <span className={`w-1.5 h-1.5 rounded-full ${s.dot}`} />
                      {inv.status}
                    </span>

                    {/* Action */}
                    <button className="w-8 h-8 rounded-full bg-[#4B2364] hover:bg-[#34094D] flex items-center justify-center shadow-sm transition-colors cursor-pointer border-none">
                      <DownloadIcon />
                    </button>
                  </div>
                );
              })
            }

            {/* Empty state */}
            {invoices.filter(inv =>
              (statusFilter === "All Status" || inv.status === statusFilter) &&
              (inv.id.toLowerCase().includes(search.toLowerCase()) || inv.customer.toLowerCase().includes(search.toLowerCase()))
            ).length === 0 && (
              <div className="py-12 text-center">
                <p className="text-[14px] text-[#7D747F] font-medium">No invoices found.</p>
              </div>
            )}
          </div>
        </div>
  );
}